// extracted by mini-css-extract-plugin
export default {"card":"CardProject_card__JI-uR","box_content":"CardProject_box_content__B6nQR","btn":"CardProject_btn__YrIvL","box_img":"CardProject_box_img__Esr05"};